'use client'

import { useEffect } from 'react'
import { useSearchParams } from '@/utils/navigation'
import { Auth0Client } from '@auth0/auth0-spa-js'
import Splash from '@/components/splash/Splash'
import { EXPLICIT_LOGOUT_SESSION_KEY } from '@/utils/authSession'

export default function SSOCallbackPage() {
    const searchParams = useSearchParams()

    useEffect(() => {
        const token = searchParams?.get('token')
        const redirectParam = searchParams?.get('redirect') || '/'

        if (!token) {
            window.location.href = '/'
            return
        }

        let redirect = '/'
        let storeName: string | null = null

        try {
            const redirectUrl = new URL(redirectParam, window.location.origin)
            if (redirectUrl.origin === window.location.origin) {
                redirect = `${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`
                storeName = redirectUrl.searchParams.get('storeName')
            }
        } catch {
            // Fall back to the default route for malformed redirect values.
        }

        // Store redirect path for after Auth0 login completes
        sessionStorage.removeItem(EXPLICIT_LOGOUT_SESSION_KEY)
        sessionStorage.setItem('sso_redirect', redirect)

        if (storeName) {
            sessionStorage.setItem('storeName', storeName)
        }

        const auth0Client = new Auth0Client({
            domain: import.meta.env.VITE_AUTH_DOMAIN!,
            clientId: import.meta.env.VITE_AUTH_CLIENT_ID!,
            authorizationParams: {
                redirect_uri: window.location.origin,
                audience: 'https://auth.neatolabs.io/',
            },
        })

        auth0Client.loginWithRedirect({
            authorizationParams: {
                connection: 'shopify-sso',
                login_hint: token,
            },
        })
    }, [searchParams])

    return <Splash text="Signing you in..." />
}
